// src/hooks/countries/useRestoreAllCountries.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllCountries } from "../../api/apiCountries";
import parseError from "../../utils/parseError";

const useRestoreAllCountries = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAll,
        isPending: isRestoringAll,
    } = useMutation({
        mutationFn: restoreAllCountries,
        onSuccess: (res) => {
            const message = res?.message || "Selected countries restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["countries"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore selected countries");
        },
    });

    return {
        restoreAllCountries: restoreAll,
        isRestoreAll: isRestoringAll,
    };
};

export default useRestoreAllCountries;
